import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Adds `<link rel="canonical">` for the current path without its query string while mounted, so
 * search engines merge the filtered, paged and localized copies of a page into one URL.
 */
export function useCanonicalUrl(isCanonical: boolean) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isCanonical) {
      return;
    }

    const canonicalLink = document.createElement("link");

    canonicalLink.rel = "canonical";
    canonicalLink.href = `${window.location.origin}${pathname}`;
    document.head.appendChild(canonicalLink);

    return () => canonicalLink.remove();
  }, [isCanonical, pathname]);
}
